var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3172,
    cy: 23.7888,
    r: 21.3344,
    stroke: "#8F90A6",
    strokeWidth: 3.96551
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1339 15.6727V24.0994M23.1339 32.5261V24.0994M23.1339 24.0994H14.542M23.1339 24.0994H31.7259",
    stroke: "#8F90A6",
    strokeWidth: 2.64367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.888a29ce16414c4e4661645713404ffa.svg";
export { ForwardRef as ReactComponent };